import { styled } from '@mui/material'

export const StyledLayout = styled('div')({
  display: 'flex',
  overflow: 'hidden',
  padding: '0',
  margin: '0',
})
